import React from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import TitleBox from '../../components/title-box'
import { FormattedMessage } from 'react-intl'

export default props => {
    useStyles(classes)
    const { shippingMethod } = props
    return <TitleBox 
    extra={<span className={classes.Title}>{shippingMethod?.title}</span>}
    title={<FormattedMessage id="shipping_method" defaultMessage="Shipping Method"/>}/>
}